<!--
 * @Description: 
 * @Author: xiaoyao
 * @since: 2020-07-07 09:54:54
 * @LastAuthor: @yangwenshan
 * @lastTime: 2021-07-27 11:40:06
--> 
<template>
  <a-modal
    title="启点车险系统服务协议"
    :width="600"
    :bodyStyle="{ height: '700px', 'overflow-y': 'scroll' }"
    :visible="visible"
    :footer="null"
    @cancel="handleCancel"
  >
    <h3>一、服务总则</h3>
    <p>
      1.1
      本《协议》为您（即：用户）与成都启点科技有限公司（以下简称：成都启点）就启点车险营销系统所提供的本软件服务达成的协议。
      特别提醒您认真阅读、充分理解本服务协议各条款，特别条款中涉及的免责条款，对用户的权利限制的条款，法律适用、争议解决方式的条款。
      <br />
      1.2
      启点车险营销系统由成都启点注册并开发，为保险机构及从业人员提供展业工具平台。
      <br />
      1.3
      启点车险营销系统只提供系统技术支持服务，服务中将使用到的第三方平台相关权限及账号均来自于您（即：用户）主动录入系统使用，相关账号及权限合规使用合规性由您（即：用户）承担责任。
      <br />
      1.4
      请您审慎阅读并选择同意或不同意本《协议》，除非您接受本《协议》所有条款，否则您无权使用服务。您的注册、付费、登录、运行等行为表明您自愿接受本协议的全部内容并受其约束，不得以任何理由包括但不限于未能认真阅读本协议等作为纠纷抗辩理由。
      <br />
      1.5 本协议第一次注册时请认真阅读，继续注册视为同意本《协议》
      <br />
      1.6 本《协议》可由成都启点随时更新，更新协议条款在系统公布即代替原来的协议条款，不再另行个别通知。如果您不接受新条款，请立即停止使用，您继续本系统服务将被视为已接受了修改后的协议。
      <br />
    </p>
    <h3>二、权利声明</h3>
    <p>
      2.1 启点车险营销系统拥有向最终用户提供的内容服务、文档（包括上述内容的升级、改进版本）的所有权和一切知识产权，包括但不限于：
      <br />
      2.1.1 启点车险电销系统提供的相关软件的著作权、版权、名称权、商标权以及由其派生的各项权利；
      <br />
      2.1.2 启点车险电销系统中的电子文档、文字、数据库、图片、图标、图示、照片、程序、音乐、色彩、版面设计以及由其派生的各项权利；
      <br />
      2.1.3 启点车险电销系统自身不会提供任何数据，但用户使用服务过程中所产生并存储于启点车险电销系统系统中的任何数据可能被收集；
      <br />
      2.2 用户不可以对该该服务运行过程中释放到任何计算机终端内存中的数据及该软件运行过程中客户端与服务器端的交互数据进行复制、更改、修改、挂接运行或创作任何衍生作品，形式包括但不限于使用截屏、插件、外挂或非经授权的第三方工具/服务接入本系统。
      <br />
      2.3 未经启点车险电销系统书面同意，用户以任何营利性、非营利性或损害启点车险电销系统利益的目的实施以下几种行为的，启点车险电销系统保留追究上述未经许可行为一切法律责任的权利：
      <br />
      2.3.1 进行编译、反编译等方式破解该系统功能行为；
      <br />
      2.3.2 利用技术手段破坏软件系统或者服务器的行为；
      <br />
      2.3.3 利用系统漏洞侵犯启点车险电销系统利益的行为；
      <br />
    </p>
    <h3>三、用户权利和责任</h3>
    <p>
      3.1 您确认，在您完成注册及实际使用我们服务时，您应当是具备完全民事权利能力和与所从事的民事行为相适应的行为能力的自然人、法人或其他组织。若您不具备前述主体资格，请勿使用服务，否则您及您的监护人应承担因此而导致的一切后果，且启点公司有权注销（永久冻结）您的账户，并向您及您的监护人索偿。如您代表一家企业、组织机构或其他法律主体进行注册实际使用本服务，则您声明和保证，您已经获得充分授权并有权代表该公司、组织机构或法律主体注册使用本服务，并受本协议地约束。
      您使用本系统车险工具服务时，应该具备保险从业资格或属于保险从业机构的员工。
      <br />
      3.2 用户服务协议终止时，您享有的启点车险电销系统服务可能同时终止。
      <br />
      3.3用户有权对启点车险营销系统的管理和服务提出批评、意见、建议，有权就客户服务相关工作向客服提出咨询。
      <br />
      3.4 用户在使用启点车险营销系统时应遵守中华人民共和国法律、法规，遵守行业管理规定（包括但不限于管理办法、禁止性和限制性行为等），并自行承担因个人原因引起的直接或间接法律责任。
      <br />
      3.5 您同意，由于技术环境的局限性及其发展，成都启点无须对启点车险营销系统的功能适用于甲方，且没有技术瑕疵承担保证责任。同时，由于保险公司管控或行业规定导致与其相关功能不能使用，成都启点不承担保证可用责任。
    </p>
    <h3>四、注册账号使用</h3>
    <p>
      4.1 启点车险营销系统根据国家法律法规要求将逐步完善用户实名认证机制，届时用户应提供真实身份信息进行注册并保证所提供的个人身份资料信息真实、完整、有效，并依据法律规定和本条款约定对所提供的信息承担相应的法律责任；
      <br />
      4.2 账号和昵称注册应符合法律法规和社会公德的要求，不得以党和国家领导人或其他名人的真实姓名、字号、艺名、笔名和不文明、不健康用语注册；
      <br />
      4.3 账户所有权归属于启点车险电销系统，用户享有该账户在平台运营期间的使用权。
      <br />
      4.4 启点车险营销系统有权审查用户注册所提供的身份信息是否真实、有效，并应积极地采取技术与管理等合理措施保障用户账号的安全、有效；用户有义务妥善保管其账号及密码，并根据启点车险营销系统的要求正确、安全地使用其账号及密码。因黑客行为或用户保管疏忽等非启点车险营销系统过错导致帐号、密码遭他人非法使用，启点车险营销系统不承担任何责任；
      <br />
    </p>
    <h3>五、信息安全保护</h3>
    <p>
      5.1 启点车险电销系统将保护用户提供的有效个人信息数据的安全。不对外向任何第三方提供、公开或共享用户注册资料中的姓名、个人有效身份证件号码、联系方式、家庭住址等个人身份信息，但下列情况除外：
      <br />
      5.1.1 用户或用户监护人授权披露的；
      <br />
      5.1.2 有关法律要求披露的；
      <br />
      5.1.3 司法机关或行政机关基于法定程序要求提供的；
      <br />
      5.1.4 启点车险电销系统为了维护自己合法权益而披露。
      <br />
      5.2 当您（个人用户）的账号申请加入某组织机构时，您在系统的所有资料即授权该机构管理员可见。
      <br />
      5.3 为向您提供更契合的软件服务，在提供服务过程中我们至少会收集以下信息：
      <br />
      5.3.1 使用信息：账号注册登录相关个人信息、组织机构信息、操作日志；
      <br />
      5.3.2 设备信息：浏览器、位置、设备型号；
      <br />
      5.3.3 工作信息：您在本系统的交易信息、订单信息、话单及录音。
      <br />
      5.4 1.3条款中涉及的第三方平台信息，启点系统只负责展示用户在第三方平台有权使用的信息，这些信息的安全保密由用户自行承担责任。
    </p>
    <h3>六、服务的终止</h3>
    <p>
      6.1 用户服务协议终止时，归属于其单位的业务人员账号可能终止服务。
      <br />
      6.2 用户实施或有重大可能实施以下行为的，启点车险电销系统有权中止对其部分或全部服务，中止提供服务的方式包括但不限于暂停对该账号的登录和使用：
      <br />
      6.1.1 提供虚假注册身份信息的行为；
      <br />
      6.1.2 发布不道德信息、广告、言论、辱骂骚扰他人，扰乱正常的平台秩序的行为；
      <br />
      6.1.3 实施违反本协议和相关规定、管理办法、公告、重要提示，对启点车险营销系统和其他用户利益造成损害的其他行为。
      <br />
      6.1.4 用非法手段盗取其他用户账号的行为；
      <br />
      6.1.5 传播非法讯息、木马病毒、外挂软件等的行为；
      <br />
      6.2 您选择了本系统的付费服务时，而又没有及时付费，该服务内容将终结，相关数据不再保留。
    </p>
    <h3>七、免责条款</h3>
    <p>
      7.1 用户因其个人原因造成账号资料保管不妥而导致个人信息数据被他人泄露造成损失的，启点车险营销系统不承担任何责任。
      <br />
      7.2 用户因除了按协议规则行为外的其他行为触犯了中华人民共和国法律法规的，责任自负，启点车险营销系统不承担任何责任。
      <br />
      7.3 基于网络环境的复杂性，启点车险营销系统不担保服务一定能满足用户的要求。因运营商机房网络设备产生的故障，成都启点不能保证恢复及时性。
      <br />
      7.4 基于网络环境的特殊性，启点车险营销系统不担保对用户限制性行为和禁止性行为的判断的准确性，用户因此产生的任何损失启点车险营销系统不承担任何责任。
    </p>
    <h3>八、特别授权</h3>
    <p>
      当您在系统使用微信、钉钉登录，录入保险公司账号等行为，表示您获得了以上第三方授权，并同意在本系统使用。
    </p>
    <h3>九、法律适用和争议解决</h3>
    <p>
      本协议的订立、效力、解释、履行和争议的解决均适用中华人民共和国法律。因本协议以及因履行本协议而产生的任何争议，双方均应本着友好协商的原则加以解决。协商解决未果，任何一方有权向人民法院提请审理。
    </p>
  </a-modal>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    show() {
      this.visible = true;
    },
    handleCancel(e) {
      this.visible = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Tools/AgreementModal.vue